import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'
import {
  Box,
  Grid,
  TextField,
  MenuItem,
  FormHelperText,
  Tooltip,
  Typography,
  Paper,
  useMediaQuery,
} from '@material-ui/core'

import constants from 'constants/index'
import theme from 'theme'

const CookieItem = ({ cookie, cookieIndex }) => {
  const { control, errors } = useFormContext()

  const disableInput = false

  const smDown = useMediaQuery(theme.breakpoints.down('sm'), {
    defaultMatches: true,
  })

  return (
    <Paper>
      <Grid container spacing={smDown ? 3 : 8} component={Box} p={2}>
        <Grid item md={3} sm={6} xs={12}>
          <Typography color="primary" variant="h6" gutterBottom>
            Plataforma de origem:
          </Typography>
          <Box display="flex" flexDirection="column" gridGap={theme.spacing(1)}>
            <Controller
              as={
                <TextField
                  placeholder="Origem"
                  error={!!errors?.cookies?.[cookieIndex]?.platform}
                  helperText={
                    <>{errors?.cookies?.[cookieIndex]?.platform?.message}</>
                  }
                  type="text"
                  size="small"
                  variant="outlined"
                  disabled={disableInput}
                  fullWidth
                  margin="none"
                />
              }
              control={control}
              name={`cookies.${cookieIndex}.platform`}
              defaultValue={cookie.platform || ''}
            />
          </Box>
        </Grid>

        <Grid md={3} sm={6} item xs={12}>
          <Typography color="primary" variant="h6" gutterBottom>
            Cookie:
          </Typography>
          <Tooltip title={cookie?.name} placement="bottom-start">
            <TextField
              type="text"
              defaultValue={cookie?.name}
              fullWidth
              disabled
              size="small"
            />
          </Tooltip>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Typography color="primary" variant="h6" gutterBottom>
            ANPD:
          </Typography>
          <Controller
            as={
              <TextField
                select
                fullWidth
                error={!!errors?.cookies?.[cookieIndex]?.categoryId}
                color="primary"
                variant="outlined"
                placeholder="Selecionar"
                disabled={disableInput}
                size="small"
                margin="none"
              >
                {constants.cookies.category.MENU_ITEMS.map((cookieCategory) => (
                  <MenuItem
                    key={cookieCategory?.id}
                    value={cookieCategory?.id}
                    disabled={cookieCategory?.disabled}
                  >
                    {cookieCategory.name}
                  </MenuItem>
                ))}
              </TextField>
            }
            control={control}
            name={`cookies.${cookieIndex}.categoryId`}
            defaultValue={cookie.category?.id || ''}
          />
          {!!errors?.cookies?.[cookieIndex] && (
            <FormHelperText error={!!errors?.cookies?.[cookieIndex]}>
              {<>{errors?.cookies?.[cookieIndex]?.categoryId?.message}</>}
            </FormHelperText>
          )}
          <Box display="none">
            <Controller
              as={<TextField />}
              control={control}
              name={`cookies.${cookieIndex}.id`}
              defaultValue={cookie?.id || ''}
            />
          </Box>
        </Grid>

        <Grid item md={3} sm={6} xs={12}>
          <Typography color="primary" variant="h6" gutterBottom>
            Tag Manager:
          </Typography>
          <TextField
            type="text"
            value={
              constants.cookies.category.STORAGE_TYPES[cookie?.category?.id] ||
              ''
            }
            fullWidth
            disabled
            placeholder="Selecione uma categoria"
            size="small"
          />
        </Grid>
      </Grid>
    </Paper>
  )
}

CookieItem.propTypes = {
  cookie: PropTypes.object.isRequired,
  cookieIndex: PropTypes.number.isRequired,
}

export default CookieItem
